import React, { useMemo, useState } from 'react';
// logic
import { mutate } from 'swr';
import t from './TicketUpdateTranslations';
import ticketService from '../../ticketService';
// components
import { FormButton } from '../ui/buttons/FormButton';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import {
  ModalContainer,
  CloseButtonContainer,
  ModalBody,
  ModalFooter,
  ModalFormContainer,
  ModalHeader,
  ModalHeaderInnerContainer,
  ModalHeaderMainText,
  ModalHeaderSecondaryText,
  ModalRegularText,
  ModalBoldText,
} from './modalComponents';
import BasicLoader from '../ui/loaders/basicLoader';
import styled from 'styled-components';
import { SectionLine } from '../ticketForm/components/SectionLine';

const WhiteBasicLoader = styled(BasicLoader)`
  & > div > div {
    background-color: white;
  }
`;
export const CloseAuctionsModal = ({ ticket, ok, cancel }) => {
  const formattedTicketId = useMemo(
    () => ticketService.utils.getFormatedId(ticket.id),
    [ticket.id]
  );

  const [isWaitingForResponse, setIsWaitingForResponse] = useState(false);
  const [hasBackendError, setHasBackendError] = useState(false);

  const goBack = (e) => {
    e.preventDefault();
    cancel();
  };

  const onSubmit = async () => {
    setIsWaitingForResponse(true);

    try {
      const lastRoute = ticket.cargo.routes[ticket.cargo.routes.length - 1];
      const routeId = lastRoute.id;
      await ticketService.callBackend.closeAuctions({
        routeId,
      });
      mutate((key) => {
        return typeof key === 'string' && key.startsWith('tickets');
      });
      ok({});
    } catch (e) {
      setIsWaitingForResponse(false);
      setHasBackendError(true);
    }

    ok({});
  };

  if (hasBackendError) {
    return (
      <ModalContainer>
        <ModalBody>
          <ModalHeader>
            <ModalHeaderInnerContainer>
              <ModalHeaderSecondaryText>{`Ticket ID. ${formattedTicketId}`}</ModalHeaderSecondaryText>
              <ModalHeaderMainText>{t.closeAuctions} </ModalHeaderMainText>
            </ModalHeaderInnerContainer>
          </ModalHeader>
          <ModalFormContainer>
            <SectionLine>
              <ModalBoldText>{t.closeAuctionBackendError}</ModalBoldText>
            </SectionLine>
          </ModalFormContainer>
        </ModalBody>
        <ModalFooter>
          <FormButton variant="ghost" onClick={goBack}>
            {t.back}
          </FormButton>
        </ModalFooter>
        <CloseButtonContainer onClick={goBack}>
          <CloseIcon />
        </CloseButtonContainer>
      </ModalContainer>
    );
  }

  return (
    <ModalContainer>
      <ModalBody>
        <ModalHeader>
          <ModalHeaderInnerContainer>
            <ModalHeaderSecondaryText>{`Ticket ID. ${formattedTicketId}`}</ModalHeaderSecondaryText>
            <ModalHeaderMainText>{t.closeAuctions} </ModalHeaderMainText>
          </ModalHeaderInnerContainer>
        </ModalHeader>
        <ModalFormContainer>
          <ModalRegularText>{t.closeAuctionsCopy1}</ModalRegularText>
          <ModalRegularText>{t.closeAuctionsCopy2}</ModalRegularText>
        </ModalFormContainer>
      </ModalBody>
      <ModalFooter>
        <FormButton variant="ghost" onClick={goBack}>
          {t.back}
        </FormButton>
        <FormButton isDisabled={isWaitingForResponse} onClick={onSubmit}>
          {isWaitingForResponse ? <WhiteBasicLoader size={16}></WhiteBasicLoader> : t.closeAuctions}
        </FormButton>
      </ModalFooter>
      <CloseButtonContainer onClick={goBack}>
        <CloseIcon />
      </CloseButtonContainer>
    </ModalContainer>
  );
};

export default CloseAuctionsModal;
